// import React, { useEffect } from "react";
// import "mathlive";

// const MathFieldComponent = () => {
//   // Suppress the ResizeObserver error
//   const resizeObserverLoopErrSilencer = () => {
//     const resizeObserverLoopErr = /ResizeObserver loop limit exceeded/;
//     window.addEventListener("error", (e) => {
//       if (resizeObserverLoopErr.test(e.message)) {
//         e.stopImmediatePropagation();
//       }
//     });
//   };
//   resizeObserverLoopErrSilencer();

//   useEffect(() => {
//     // Any MathLive-related initialization can be done here
//     const mathFieldElement = document.querySelector("math-field");
//     if (mathFieldElement) {
//       // Perform any setup needed for the math-field
//       mathFieldElement.setOptions({
//         virtualKeyboardMode: "manual", // Example option
//       });
//     }
//   }, []);

//   return (
//     <div style={{ padding: "20px" }}>
//       <math-field style={{ width: "200px" }}></math-field>
//     </div>
//   );
// };

// export default MathFieldComponent;


import React, { useEffect } from "react";
import "mathlive"; // Import MathLive library

const MathLiveComponent = ({ onLatexChange }) => {
  useEffect(() => {
    const mathField = document.getElementById("mathfiled");

    if (mathField) {
      window.mathVirtualKeyboard.container = document.getElementById("keyboardcontainer");
      window.mathVirtualKeyboard.show();

      mathField.addEventListener("input", () => {
        const latex = mathField.getValue("latex");
        if (onLatexChange) {
          onLatexChange(latex); // Pass the updated LaTeX to the parent
        }
      });

      return () => {
        window.mathVirtualKeyboard.hide();
      };
    }
  }, [onLatexChange]);

  return (
    <div>
      <math-field id="mathfiled" style={{ width: "100%"}}></math-field>
      <div id="keyboardcontainer" style={{ height: "300px", width: "100%"  }}></div>
    </div>
  );
};

export default MathLiveComponent;
